var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_5890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5652 2.36621C8.16835 2.36621 2.98828 7.55787 2.98828 13.9547C2.98828 20.3516 8.16835 25.5433 14.5652 25.5433C20.9737 25.5433 26.1653 20.3516 26.1653 13.9547C26.1653 7.55787 20.9737 2.36621 14.5652 2.36621ZM10.5208 9.31933C11.4827 9.31933 12.2591 10.0958 12.2591 11.0576C12.2591 12.0195 11.4827 12.7959 10.5208 12.7959C9.55898 12.7959 8.78255 12.0195 8.78255 11.0576C8.78255 10.0958 9.55898 9.31933 10.5208 9.31933ZM14.5768 20.9079C11.9346 20.9079 9.68645 18.9842 8.78255 16.2725H20.3711C19.4672 18.9842 17.219 20.9079 14.5768 20.9079ZM18.6328 12.7959C17.671 12.7959 16.8945 12.0195 16.8945 11.0576C16.8945 10.0958 17.671 9.31933 18.6328 9.31933C19.5946 9.31933 20.3711 10.0958 20.3711 11.0576C20.3711 12.0195 19.5946 12.7959 18.6328 12.7959Z",
    fill: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_5890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8125,
    height: 27.8125,
    fill: "white",
    transform: "translate(0.671875 0.0478516)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.f64fba38429b61ab4708a83e6435e4a5.svg";
export { ForwardRef as ReactComponent };